import React from 'react';

export default function GoogleNotLinkedText() {
  return (
    <>
      <p>
        <b>Google</b>
        {' '}
        account is not linked.
      </p>
      <p>Click the button to link it.</p>
    </>
  );
}
